import { render, staticRenderFns } from "./DefectSelectDialog.vue?vue&type=template&id=03f9b24c"
import script from "./DefectSelectDialog.vue?vue&type=script&lang=ts"
export * from "./DefectSelectDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports